import React from 'react'
import { Tools } from './Tools'
import { DownloadLinks } from './DownloadLinks'

export const LinksContainer = () => {
  return (
    <div>
      <Tools />
      <DownloadLinks />
    </div>
  )
}
